import type { DisplayCurrency } from './types'

const EU_COUNTRY_CODES = new Set([
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT',
  'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
])

export function currencyFromCountryCode(country: string | null | undefined): DisplayCurrency {
  const c = (country ?? '').trim().toUpperCase()
  if (!c) return 'USD'
  if (c === 'AU') return 'AUD'
  if (c === 'GB' || c === 'UK') return 'GBP'
  if (EU_COUNTRY_CODES.has(c)) return 'EUR'
  if (c === 'US') return 'USD'
  return 'USD'
}

/** Client fallback when geo API is unavailable. */
export function detectCurrencyFromBrowser(): DisplayCurrency {
  if (typeof window === 'undefined') return 'USD'

  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone ?? ''
    if (tz.startsWith('Australia/')) return 'AUD'
  } catch {
    /* ignore */
  }

  try {
    const langs = navigator.languages?.length ? navigator.languages : [navigator.language]
    for (const lang of langs) {
      const l = (lang ?? '').toLowerCase()
      if (l.includes('-au')) return 'AUD'
      if (l.includes('-gb') || l.includes('-uk')) return 'GBP'
      if (/^de|^fr|^it|^es|^nl|^pt|^pl|^ie/.test(l.split('-')[0] ?? '')) {
        const region = l.split('-')[1]?.toUpperCase()
        if (region && EU_COUNTRY_CODES.has(region)) return 'EUR'
      }
    }
  } catch {
    /* ignore */
  }

  return 'USD'
}

export function isValidDisplayCurrency(value: string): value is DisplayCurrency {
  return value === 'USD' || value === 'AUD' || value === 'GBP' || value === 'EUR'
}
